
    import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator';

    @Component({
        model: {
            event: 'input',
            prop: 'value'
        }
    })
    export default class OptionsFieldsValueUnit extends Vue {
        @Prop() value;
        @Prop() option;

        @Emit('input')
        setValue(event, key) {
            return {
                ...this.value,
                [key]: event
            };
        }

        get options() {
            return this.option.units;
        }
    }
